import baseTheme from '../common/base-theme';
import type { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import { CordovaCustomizations } from '../templates-info';

const cordovaTheme = (customizations: CordovaCustomizations): ResumeTheme => {
  const calcSize = getCalcSize(customizations.baseSize);
  const theme = {
    ...baseTheme,
    baseSize: customizations.baseSize,
    print: {
      ...baseTheme.print,
      backgroundColor: customizations.background,
      paddingX: calcSize(6.25, 60, 100),
      paddingY: calcSize(3.75, 30, 60),
    },
    web: {
      ...baseTheme.web,
      contentWidth: 800 + baseTheme.web.paddingX[1] * 2,
      backgroundColor: customizations.background,
    },
    fonts: {
      body: 'InterPDF, -apple-system, sans-serif',
      heading: '"EB Garamond", sans-serif',
    },
    colors: {
      text1: customizations.text1,
      text2: customizations.text2,
      text3: customizations.text3,
      accent1: customizations.accent1,
      accent2: customizations.accent2,
      accent3: customizations.accent3,
      background: customizations.background,
    },
    fontWeights: {
      body: 400,
      heading: 400,
      bold: 700,
    },
    lineHeights: {
      body: 1.6,
      heading: 1.4,
    },
    letterSpacings: {
      body: 'normal',
      caps: '1.2px',
    },
    text: {
      // Base text styles. Inherited by everything else.
      heading: {
        fontFamily: 'heading',
        lineHeight: 'heading',
        fontWeight: 'heading',
        color: 'text1',
      },
      body: {
        fontFamily: 'body',
        lineHeight: 'body',
        fontWeight: 'body',
        color: 'text2',
        fontSize: 14,
      },
      // Resume text elements
      resumeHeading: {
        variant: 'text.body',
        fontSize: 14,
        marginBottom: calcSize(0.125),
        fontWeight: 'bold',
        color: 'text1',
      },
      resumeSummary: {
        variant: 'text.heading',
        fontSize: 24,
      },
      sectionHeading: {
        variant: 'text.body',
        flexGrow: 0,
        flexShrink: 0,
        width: ['100%', 220],
        marginBottom: [24, calcSize(2)],
      },
      sectionItemHeading: {
        variant: 'text.heading',
        fontSize: 24,
        lineHeight: 1.35,
        marginBottom: [6, calcSize(0.625)],
        flexShrink: 0,
        flexGrow: 0,
        width: 220,
        paddingRight: 16,
        display: ['none', 'block'],
      },
      paragraph: {
        variant: 'text.body',
        mb: calcSize(0.375),
      },
      listItem: {
        variant: 'text.body',
        mb: calcSize(0.375),
      },
      summaryListItem: {
        variant: 'text.listItem',
        marginLeft: 16,
        mb: calcSize(0.25),
        paddingLeft: 0,
      },
      blockListItemHeading: {
        fontFamily: 'heading',
        color: 'text1',
        fontSize: 20,
        marginBottom: calcSize(0.4375),
      },
    },
    // Containers used to add margin bottom
    headerContainer: {
      marginBottom: calcSize(3.5),
    },
    sectionContainer: {
      marginBottom: [50, calcSize(4.375)],
    },
    detailSectionItemContainer: {
      marginBottom: calcSize(2),
    },
    blockListSectionItemContainer: {
      marginBottom: calcSize(1.25),
    },
    summaryList: {
      padding: 0,
    },
  };
  return theme;
};

export default cordovaTheme;
